export default [
  {
    path: '/student-top-fives',
    name: 'studnet-top-five',
    meta: { requiresAuth: true },
    component: () => import('@/pages/studnet-top-five/index.vue')
  }
]
